import React from "react";

export const useDragDrop = (onItemSwap, currentItems, setCurrentItems) => {
    const onDragEnd = (result) => {
        if (!result.destination) {// dropped outside the list
            return;
        }
        const reorder = (list, startIndex, endIndex) => {
            const result = Array.from(list);
            const [removed] = result.splice(startIndex, 1);
            result.splice(endIndex, 0, removed);
            return result;
        };

        const nextItems = reorder(
            currentItems,
            result.source.index,
            result.destination.index
        );

        if (onItemSwap) {
            onItemSwap(
                currentItems,
                nextItems,
                {
                    source: result.source,
                    destination: result.destination
                }
            )
        }
        setCurrentItems(nextItems);
    };

    return {
        items: currentItems,
        onDragEnd: onDragEnd
    };
}


// WEBPACK FOOTER //
// ./src/components/DragDrop/useDragDrop.js